module.exports = __webpack_public_path__ + "img/app-agrotools-app-store-qrcode.e2ed598f.svg";